module.exports = __webpack_public_path__ + "img/04.3a146ae9.png";